// import React from 'react';
import Dashboard from "views/Front/Dashboard";

const FrontRoutes = [
  { path: "/", exact: true, name: "Dashboard", component: Dashboard }
];

export default FrontRoutes;
